<template>
  <section class="bloc-text-simple" :class="{ 'cherry' : content.cherry_mode }">
    <div class="bloc-text-simple__wrapper">
      <p class="bloc-text-simple__text" v-html="content.text"></p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TextSimple',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-text-simple {
    width: 100vw;
    background: $th-grey;
    padding: 70px 0;
    overflow: hidden;
    position: relative;

     &.cherry {
        background: $th-cherry;
        padding: 80px 0;
      }

    &__wrapper {
      width: grid_m(5, 4);
      margin: 0 auto;

      @include media($from: small) {
        width: grid(8, 7);
      }
    }

    &__text {
      position: relative;
      font-size: 18px;
      font-family: "Georgia";
      color: $th-grey;
      text-align: left;
      display: block;
      line-height: 1.7;

      .cherry & {
        text-align: center;
        color: $th-gold;
        font-size: 22px;
        line-height: 1.5;
      }

      sup {
        font-size: 12px;
      }

      i {
        margin-right: 4px;
      }

      .big-yellow {
        text-transform: uppercase;
        color: $th-yellow;
      }

      .big-upper {
        font-family: "Gotham Book";
        text-transform: uppercase;
        font-size: 22px;
      }

      .text-center {
        text-align: center;
        max-width: 100%;
        margin: 0 auto;
        margin-top: 10px;
        line-height: 1.6;

        @include media($from: small) {
          max-width: 80%;
        }
      }
    }
  }

  .bloc-text-simple + .bloc-text-simple {
    padding-top: 0;
  }
</style>
